import { render, staticRenderFns } from "./ActivityComment.vue?vue&type=template&id=be851360&scoped=true&"
import script from "./ActivityComment.vue?vue&type=script&lang=js&"
export * from "./ActivityComment.vue?vue&type=script&lang=js&"
import style0 from "./ActivityComment.vue?vue&type=style&index=0&id=be851360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be851360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be851360')) {
      api.createRecord('be851360', component.options)
    } else {
      api.reload('be851360', component.options)
    }
    module.hot.accept("./ActivityComment.vue?vue&type=template&id=be851360&scoped=true&", function () {
      api.rerender('be851360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityComment.vue"
export default component.exports